<!--
 * @Author: 仙道
 * @Date: 2022-07-04 00:04:37
 * @LastEditTime: 2022-09-22 21:52:23
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/modules/TaskDeviceDetail.vue
-->
<template>
  <div id="printContent" ref="print">
    <a-descriptions bordered class="mt-15px px-25px mb-20px" size="small">
      <a-descriptions-item label="保养计划">{{ model.planName || '临时任务' }}</a-descriptions-item>
      <a-descriptions-item label="编号">{{ model.taskCode }}</a-descriptions-item>
      <a-descriptions-item label="负责人">{{ model.finishId_dictText ||'--'}}</a-descriptions-item>

      <a-descriptions-item
        label="任务状态"
      >{{ $filterDictTextByCache('dev_maintaince_task_status', detailData.taskStatus) }}</a-descriptions-item>

      <a-descriptions-item label="保养时间">{{ detailData.realTime }}</a-descriptions-item>
    </a-descriptions>
    <!-- <div class="no-print mt-10px" style="text-align: right">
      <a-button ghost type="primary" v-print="'#printContent'">打印</a-button>
    </div>-->

    <task-device-table :dataSource="dataList" ref="tasktable" type="detail" v-if="tableLoading" />

    <DevBpbjLeadoutRecordList :canEdit="disabled" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
  </div>
</template>

<script>
  import { groupBy } from 'lodash';
  import { getAction } from '@/api/manage'
  import TaskDeviceTable from './TaskPlanTable.vue'
  import DevBpbjLeadoutRecordList from './DevBpbjLeadoutRecordList'
  export default {
    name: 'TaskDeviceDetail',
    components: {
      TaskDeviceTable,
      DevBpbjLeadoutRecordList
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    // 定义属性
    data () {
      return {
        dataList: [],
        model: {
        },
        modelDefault: {},
        tableLoading: false,
        taskById: '/maintenance/devMaintainceTask/getDetailById',
        detailData: {},
        deviceData: {} //设备集合
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.modelDefault = JSON.parse(JSON.stringify(this.model));

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        console.info(JSON.stringify(record))
        this.tableLoading = false
        this.deviceData = {}
        // 调用 消耗备品备件列表数据
        this.$refs.devBpbjLeadoutRecordList.getData(record.id)
        getAction(this.taskById, { id: record.id }).then(res => {

          this.detailData = res.result
          if (res.result && res.result.list) {

            const grouped = groupBy(res.result.list, v => v.devName);
            this.deviceData = grouped
            // 其次合并，第一项占行，后续为0
            const result = Object.keys(grouped)
              .map(k => grouped[k].map((v, i, arr) => ({ ...v, rowSpan: i === 0 ? arr.length : 0 })))
              .flatMap(v => v);

            this.dataList = result.filter(item => item.isExecute)
          }
          this.tableLoading = true
        })
        this.visible = true;
      }
    }
  }
</script>

<style lang='less' scoped>
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    color: #000000 !important;
    -webkit-tap-highlight-color: #000000 !important;
  }
</style>